import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class SharedInvestmentService {
  private dataInvestmentSource = new BehaviorSubject<any>({});

  getDataInvestmentsInfo$ = this.dataInvestmentSource.asObservable();
  constructor() { }
  
  /**
   * [setData]
   * @param data 
   * @param origin 
   */
  setDataInvestments(data: any, origin: string) {
    const objSend = {
      data: data,
      origin: origin
    };

    this.dataInvestmentSource.next(objSend)
  }
}
